import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";
import { AppState } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables, GlobalRef } from '../../../common/global-variables';
import { DashboardServiceVcd } from './dashboard.service';
import { VcaAlertsService } from '../../../common/vca-alerts/vca-alerts.service';
import { AuthService } from '../../auth/auth.service';
import { AUTH_CONSTANTS } from '../../auth/auth-constants';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../refresh-shared-service';
import { storagePrettyConverter, checkIfUserHasRoles } from '../../../common/utils/utils';
import { GuidedTour, GuidedTourBuilder } from '../../../app/services/guided-tour-builder/guided-tour-builder.service'

export const DASHBOARD_OVERVIEW_TOUR_ID = 'dashboard.overview';

export class DashboardGuidedTourData {

    private overviewTour;

    constructor(
        private admininstratorView:boolean,
        private translate: TranslateService,
        private authService: AuthService,
        private dashboardService: DashboardServiceVcd,
        private globalRef: GlobalRef,
        private guidedTourBuilder: GuidedTourBuilder) {

            this.guidedTourBuilder.createTour(DASHBOARD_OVERVIEW_TOUR_ID,
                ()=> {console.debug('Tour was Started')},
                ()=> {console.debug('Tour was Canceled');
                    this.blockOverviewTourOnNextSession();
                    },
                ()=> {console.debug('Tour was Completed');
                    this.blockOverviewTourOnNextSession();
                    }
            );

        }


    /*
     * - - - - - Building 'overview' tour for Dashboard - - - - - - - - -
     */

    /**
     *
     * JQuery Elements:
     *  dashboard_vcenters
        dashboard_organization
        dashboard_vdc_count
        dashboard_vm_count
        dashboard_gateway_count
        dashboard_network_count
        dashboard_directconnect_count
        dashboard_resource_view
        dashboard_mini_activity_log
     */
    buildOverviewGuidedTour() {

        this.overviewTour = this.guidedTourBuilder.findTour(DASHBOARD_OVERVIEW_TOUR_ID);
        let allSteps = {
            step_welcome: {
                title: this.translate.instant('guidedTour.hcx.welcome.head'),
                text: this.translate.instant('guidedTour.hcx.welcome.mesg'),
                //attachTo: {element:'#header_nav_dashboard', on:'bottom'},
                classes: 'guided-tour',
                buttons: [
                    {
                        text: 'Start Tour',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    },
                    {
                        text: 'Skip',
                        classes: 'shepherd-button-secondary btn-link',
                        action: () => this.overviewTour.cancel()
                    }
                    ]
                },
            step_0: {
                title: this.translate.instant('guidedTour.dashboard.splash.head'),
                text: this.translate.instant('guidedTour.dashboard.splash.mesg'),
                attachTo: {element:'#header_nav_dashboard', on:'bottom'},
                classes: 'guided-tour',
                buttons: [
                    {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    },
                    ]
                },
            step_vc1: {
                title: this.translate.instant('guidedTour.dashboard.overview.vcenters.head'),
                text: this.translate.instant('guidedTour.dashboard.overview.vcenters.mesg'),
                //attachTo: {element:'#header_nav_services', on: 'bottom'},
                attachTo: {element:'#dashboard_vcenters', on: 'right'},
                //classes: 'shepherd-theme-arrows',
                classes: 'guided-tour',
                //advanceOn: '.side-menu click',
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        //classes: 'btn btn-link',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },
            step_vcd1: {
                title: this.translate.instant('guidedTour.dashboard.overview.vcdOrganization.head'),
                text: this.translate.instant('guidedTour.dashboard.overview.vcdOrganization.mesg'),
                attachTo: {element:'#dashboard_organization', on: 'right'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        //classes: 'btn btn-link',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },
            step_vcd2: {
                title: this.translate.instant('guidedTour.dashboard.overview.vcdOrgVdcs.head'),
                text: this.translate.instant('guidedTour.dashboard.overview.vcdOrgVdcs.mesg'),
                attachTo: {element:'#dashboard_vdc_count', on: 'right'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        //classes: 'btn btn-link',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },
            step_3: {
                title: this.translate.instant('guidedTour.dashboard.overview.virtualMachines.head'),
                text: this.translate.instant('guidedTour.dashboard.overview.virtualMachines.mesg'),
                attachTo: {element:'#dashboard_vm_count', on: 'right'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        //classes: 'btn btn-link',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },

            step_4: {
                title: this.translate.instant('guidedTour.dashboard.overview.edgeGateways.head'),
                text: this.translate.instant('guidedTour.dashboard.overview.edgeGateways.mesg'),
                attachTo: {element:'#dashboard_gateway_count', on: 'bottom'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        //classes: 'btn btn-link',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },
            step_5: {
                title: this.translate.instant('guidedTour.dashboard.overview.networks.head'),
                text: this.translate.instant('guidedTour.dashboard.overview.networks.mesg'),
                attachTo: {element:'#dashboard_network_count', on: 'bottom'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        //classes: 'btn btn-link',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },
            step_6: {
                title: this.translate.instant('guidedTour.dashboard.overview.directConnects.head'),
                text: this.translate.instant('guidedTour.dashboard.overview.directConnects.mesg'),
                attachTo: {element:'#dashboard_directconnect_count', on: 'left'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        //classes: 'btn btn-link',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },
            step_7: {
                title: this.translate.instant('guidedTour.dashboard.overview.resourceUsage.head'),
                text: this.translate.instant('guidedTour.dashboard.overview.resourceUsage.mesg'),
                attachTo: {element:'#dashboard_resource_view', on: 'right'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        //classes: 'btn btn-link',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Next',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                },
            step_8: {
                title: this.translate.instant('guidedTour.dashboard.overview.miniActivityLogs.head'),
                text: this.translate.instant('guidedTour.dashboard.overview.miniActivityLogs.mesg'),
                attachTo: {element:'#dashboard_mini_activity_log', on: 'left'},
                buttons: [
                    {
                        text: 'Back',
                        classes: 'shepherd-button-secondary',
                        //classes: 'btn btn-link',
                        action: () => this.overviewTour.back()
                    }, {
                        text: 'Finish',
                        action: () => this.overviewTour.next(),
                        classes: 'shepherd-button-example-primary'
                    }
                    ]
                }
        };

        this.guidedTourBuilder.addStep(DASHBOARD_OVERVIEW_TOUR_ID, 'step_welcome', allSteps['step_welcome']);
        this.guidedTourBuilder.addStep(DASHBOARD_OVERVIEW_TOUR_ID, 'step_0', allSteps['step_0']);

        if(this.authService.VREALM_TYPE === AUTH_CONSTANTS.VC) {
            this.guidedTourBuilder.addStep(DASHBOARD_OVERVIEW_TOUR_ID, 'step_vc1', allSteps['step_vc1']);
        }

        if(this.authService.VREALM_TYPE === AUTH_CONSTANTS.VCD) {
            if(this.admininstratorView) {
                this.guidedTourBuilder.addStep(DASHBOARD_OVERVIEW_TOUR_ID, 'step_vcd1', allSteps['step_vcd1']);
            }
            this.guidedTourBuilder.addStep(DASHBOARD_OVERVIEW_TOUR_ID, 'step_vcd2', allSteps['step_vcd2']);
        }

        this.guidedTourBuilder.addStep(DASHBOARD_OVERVIEW_TOUR_ID, 'step_3', allSteps['step_3']);
        this.guidedTourBuilder.addStep(DASHBOARD_OVERVIEW_TOUR_ID, 'step_4', allSteps['step_4']);
        this.guidedTourBuilder.addStep(DASHBOARD_OVERVIEW_TOUR_ID, 'step_5', allSteps['step_5']);
        this.guidedTourBuilder.addStep(DASHBOARD_OVERVIEW_TOUR_ID, 'step_6', allSteps['step_6']);
        if(this.admininstratorView) {
            try {
                this.guidedTourBuilder.addStep(DASHBOARD_OVERVIEW_TOUR_ID, 'step_7', allSteps['step_7']);
            } catch (e) {
                console.debug('Resource not available, so skipping the Tour step ', DASHBOARD_OVERVIEW_TOUR_ID, '.resources');
            }
        }
        this.guidedTourBuilder.addStep(DASHBOARD_OVERVIEW_TOUR_ID, 'step_8', allSteps['step_8']);

    }

    private blockOverviewTourOnNextSession() {
        this.globalRef.setShowHcxDashboardOverviewTour = false;
    }

    private isBlockedOverviewTourOnNextSession() : boolean {
        return !this.globalRef.isToShowHcxDashboardOverviewTour;
    }

    private ensureOverviewTourOnNextSession() {
        this.globalRef.setShowHcxDashboardOverviewTour = true;
    }

    /**
     * Need to save state so, we know if we need to load in the next session or not.
     */
    parkToursAndCleanup() {
        let isOverviewTourAlreadyBlocked = this.isBlockedOverviewTourOnNextSession();
        this.guidedTourBuilder.exitAllTours();
        this.guidedTourBuilder.destroyAllTours();
        if(!isOverviewTourAlreadyBlocked) {
            this.ensureOverviewTourOnNextSession();
        }
    }


    /**
     * This method is idempotent - if the tour is already started,
     * does nothing.
     */
    startOverviewTourIfNotBlocked(){
        if(!this.isBlockedOverviewTourOnNextSession()) {
            console.debug('Starting ', DASHBOARD_OVERVIEW_TOUR_ID, ' Guided Tour!! ',
                this.guidedTourBuilder.findTour(DASHBOARD_OVERVIEW_TOUR_ID));
            this.guidedTourBuilder.startTour(DASHBOARD_OVERVIEW_TOUR_ID);
        } else {
            console.debug('Tour was completed/skipped before, so not starting again ', DASHBOARD_OVERVIEW_TOUR_ID, ' Guided Tour!!');
        }
    }

    /*
     * - - - - - Building 'Next' tour for Dashboard - - - - - - - - -
     *
     * // Similarly, add 'build' and 'start' methods for more tours...
     */
}


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.guidedtour.data.ts